import styled from "@emotion/styled";

export const ToolbarSeparator = styled.div`
  background-color: ${({ theme }) => theme.colorsV2.grey[100]};
  width: 1px;
  height: 25px;
`;
